import React, { Component } from 'react'
import { bool } from 'prop-types'
import maskInput from 'vanilla-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import { createPercentageMask } from './BetterBuyflow/fieldHelpers'

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy')
const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
const phoneMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

export default class MaskedField extends Component {
  static propTypes = {
    currency: bool,
    date: bool,
    phone: bool,
    percentage: bool
  }

  static defaultValues = {
    currency: false,
    date: false,
    phone: false,
    percentage: false
  }

  parseMask = mask => {
    if (Array.isArray(mask)) {
      return mask.map(v => {
        const mightBeRegExp = typeof v === 'string' && v.length > 2
        const [, pattern] = mightBeRegExp ? v.match(/\/(.+?)\//) : []
        if (pattern) {
          return new RegExp(pattern)
        }
        return v
      })
    }
    return mask
  }

  initTextMask = () => {
    const {
      currency,
      date,
      phone,
      percentage,
      mask,
      pipe,
      guide,
      value,
      ...props
    } = this.props

    const inputPipe = date ? autoCorrectedDatePipe : pipe
    const inputGuide = guide === true || date === true
    const inputMask = currency
      ? createNumberMask()
      : date
        ? dateMask
        : phone
          ? phoneMask
          : percentage
            ? createPercentageMask
            : this.parseMask(mask)

    try {
      const config = {
        inputElement: this.input,
        ...props,
        guide: inputGuide,
        pipe: inputPipe,
        mask: inputMask,
        placeholderChar: '\u2000',
        keepCharPositions: !!date
      }
      this.maskedInput = maskInput(config)
    } catch (error) {
      console.error(error)
    }

    const updateValue = (value || '').toString()
    this.maskedInput.textMaskInputElement.update(updateValue)
  }

  onInput = event => {
    this.onChange(event)
  }

  onChange = event => {
    this.maskedInput.textMaskInputElement.update(event.currentTarget.value)
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(event)
    }
  }
  componentDidMount () {
    this.initTextMask()
  }

  componentDidUpdate () {
    this.initTextMask()
  }

  componentWillUnmount () {
    this.maskedInput.destroy()
  }

  render () {
    const {
      value,
      currency,
      date,
      phone,
      percentage,
      ...props
    } = this.props
    return (
      <input
        {...props}
        defaultValue={value}
        ref={ref => {
          this.input = ref
          if (typeof props.ref === 'function') {
            props.ref(ref)
          }
        }}
        onInput={this.onInput}
      />
    )
  }
}
